import { GetStaticProps } from 'next';
import { ButtonVariants } from '../../../../components/Atoms/Button';
import { StickyCTA } from '../../../../components/CTA/StickyCTA';
import { FILE_NOW_TEXT } from '../../../../components/CTA/constants';
import { ClearInNavbar } from '../../../../components/Navbar/ClearNavbar';
import HeroRewardComponent from '../../../../components/S/Rewards/HeroRewardComponent';
import RewardCategory from '../../../../components/S/Rewards/rewards_category';
import {
  NAV_TYPES,
  b2cData,
} from '../../../../components/cms/layout/components/header';
import { Meta } from '../../../../layout/Meta';
import { returnNoProps } from '../../../../utils/UtilFunctions';
import { staticPropsWrapper } from '../../../../utils/static-pages/utils';

const RewardsPage = (): JSX.Element => {
  return (
    <>
      <ClearInNavbar data={b2cData} />
      <div className="wg-container">
        <Meta
          title="Rewards Dashboard"
          description=""
          canonical="https://cleartax.in/s/rewards"
        />
        <HeroRewardComponent />
        {/* rewards */}
        <RewardCategory />
      </div>
      <StickyCTA
        buttonText={FILE_NOW_TEXT}
        buttonStyle={ButtonVariants.bluefilled}
        type={NAV_TYPES.B2C}
      />
    </>
  );
};

export const getStaticProps: GetStaticProps = staticPropsWrapper(
  __filename,
  () => {
    return returnNoProps();
  }
);

export default RewardsPage;
